<template>
  <custom-dialog :title="model.title" :visible="visible" v-on="$listeners" width="400px">
    <div class="dialog-body reset-password-bd">
      <el-form :model="form" ref="form" :rules="rules">
        <el-form-item prop="pwd">
          <el-input clearable :type="inputType" v-model="form.pwd" :placeholder="$t('base_reset_pwd_dialog.qsrxmm')">
            <i class="el-icon-edit el-input__icon" v-if="inputType === 'text'" @click="inputType = 'password'" slot="suffix"></i>
            <i class="el-icon-view el-input__icon" v-if="inputType === 'password'" @click="inputType = 'text'" slot="suffix"></i>
          </el-input>
        </el-form-item>
      </el-form>
      <p class="tip">{{ $t('base_reset_pwd_dialog.mmcdw816wbszfhzmrylz') }}</p>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="visible = false">{{ $t('Common.com_cancel') }}</el-button>
      <el-button type="primary" :disabled="loading" @click="savePassword">{{ $t('Common.com_confirm') }}</el-button>
    </div>
  </custom-dialog>
</template>

<script>
import apis from '@/utils/apis';
import dialogMixins from '@/mixins/dialog_mixins.js';

export default {
  mixins: [dialogMixins],
  data() {
    return {
      inputType: 'password',
      loading: false,
      form: {
        pwd: '',
      },
    };
  },
  computed: {
    rules() {
      return {
        pwd: [
          {
            required: true,
            min: 8,
            max: 16,
            message: this.$t('base_reset_pwd_dialog.mmcdbxz816wzj'),
          },
          {
            validator: null,
            message: this.$t('base_reset_pwd_dialog.bxbhszfhzmrylz'),
          },
        ],
      };
    },
  },
  mounted() {
    this.formRule();
  },
  methods: {
    formRule: function () {
      this.rules.pwd[1].validator = (rule, value, callback) => {
        const reg = /(?!.*\s)(?!^[\u4e00-\u9fa5]+$)(?!^[0-9]+$)(?!^[A-z]+$)(?!^[^A-z0-9]+$)^.{8,16}$/;
        if (!reg.test(value.toString())) {
          callback(new Error());
        } else {
          callback();
        }
      };
    },
    // 重置密码
    savePassword: function () {
      this.$refs.form.validate((valid) => {
        if (!valid) {
          return;
        }
        this.$postJSON(
          apis.ResetPwd,
          {
            userId: this.model.data,
            newPwd: this.encrypt(this.form.pwd),
          },
          true
        ).then(() => {
          this.visible = false;
          this.$message({
            type: 'success',
            message: this.$t('Common.com_handle_success'),
          });
        });
      });
    },
  },
};
</script>

<style lang="scss">
.reset-password-bd {
  .tip {
    line-height: 40px;
    color: #b1b1b1;
    font-size: 12px;
    padding-left: 6px;
  }
}
</style>
